<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let firstName = '';
  export let lastName = '';
  export let phone = '';
  export let email = '';
  export let website = '';
  export let type = '';

  const canSubmit = () => {
    return Boolean(firstName && phone && email) || false;
  }

  const onInput = (e) => {
    dispatch('input', {
      canSubmit: canSubmit(),
      state: {
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        email: email,
        website: website,
        type: type,
      }
    });
  }
</script>

<style>
  .row {
    margin-top: 1vw;
  }

  .row > .form-control:not(:last-child) {
    margin-right: 1vw;
  }

  /* Small devices (landscape phones, 767px and down) */
  @media (max-width: 767px) {
    .row {
      flex-direction: column;
      width: 100%;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) {
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {

  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
  }

  /* Super large devices (large desktops, 1400px and up) */
  @media (min-width: 1400px) {
  }
</style>

<main>
  <div class="row row-between">
    <div class="form-control">
      <label for="first-name">First name</label>
      <input
        id="first-name"
        type="text"
        placeholder="e.g John"
        bind:value={firstName}
        on:input={onInput}
        required>
    </div>
    <div class="form-control">
      <label for="last-name">Last name</label>
      <input
        id="last-name"
        type="text"
        placeholder="e.g Doe"
        bind:value={lastName}
        on:input={onInput}>
      </div>
  </div>
  <div class="row">
    <div class="form-control">
      <label for="phone">Phone</label>
      <input
        id="phone"
        type="phone"
        placeholder="e.g 902-000-0000"
        bind:value={phone}
        on:input={onInput}
        required>
    </div>
  </div>
  <div class="row">
    <div class="form-control">      
      <label for="email">Email</label>
      <input
        id="email"
        type="email"
        placeholder="e.g me@example.com"
        bind:value={email}
        on:input={onInput}
        required>
    </div>
  </div>
  <div class="row">
    <div class="form-control">
      <label for="website">Website</label>
      <input
        id="website"
        type="url"
        placeholder="e.g https://mysite.com"
        bind:value={website}
        on:input={onInput}>
    </div>
  </div>
</main>